/* ============================================================
   FMX Reviews — asset/fmx-reviews.js
   Load via: asset_url filter for fmx-reviews.js with defer
   ============================================================ */
(function () {
  'use strict';

  /* ── Guard: only run if section exists ── */
  if (!document.getElementById('fmxToggle')) return;

  /* ── Read product config from JSON tag ── */
  var _cfg = {};
  try {
    var _cfgEl = document.getElementById('fmx-rv-config');
    if (_cfgEl) _cfg = JSON.parse(_cfgEl.textContent);
  } catch(e) {}
  var PRODUCT_TITLE = _cfg.productTitle || '';
  var PRODUCT_PRICE = _cfg.productPrice || '';
  var PRODUCT_IMAGE = _cfg.productImage || null;

  /* ── Inject product info into modal ── */
  var modalProduct = document.getElementById('fmxModalProduct');

  /* ── 1. Product ID — unique key per product ── */
  var PRODUCT_ID = String(
    _cfg.productId
      || (window.Shopify && window.Shopify.product && window.Shopify.product.id)
      || window.location.pathname
  );

  /* ── FIREBASE CONFIG ── */
  var FIREBASE_DB_URL = 'https://fut-bol-max-default-rtdb.firebaseio.com/';
  var FIREBASE_PATH   = '/fmx_reviews/' + PRODUCT_ID;
  var FIREBASE_BASE   = FIREBASE_DB_URL + FIREBASE_PATH;

  /* ── 2. Reviews array ── */
  var reviews    = [];
  var formRating = 0;
  var sortMode   = 'newest';
  var starFilter = 0;
  var searchQ    = '';

  /* ── 3. LocalStorage cache key ── */
  var CACHE_KEY   = 'fmx_cache_'   + PRODUCT_ID;
  var PENDING_KEY = 'fmx_pending_' + PRODUCT_ID;

  /* ── Cache helpers ──
     Static reviews (flagged _static:true) are never written to
     localStorage — they live in the liquid template and are always
     available, so caching them would waste space and cause stale-data
     confusion if the static list is ever updated.
  ── */
  function cacheReviews() {
    try {
      var toCache = reviews.filter(function(r) { return !r._static; });
      localStorage.setItem(CACHE_KEY, JSON.stringify(toCache));
    } catch(e) {}
  }

  function loadCache() {
    try {
      var c = localStorage.getItem(CACHE_KEY);
      if (c) {
        var parsed = JSON.parse(c);
        if (Array.isArray(parsed) && parsed.length) {
          reviews = parsed;
          return true;
        }
      }
    } catch(e) {}
    return false;
  }

  /* ── Pending queue ── */
  function getPending() {
    try {
      var p = localStorage.getItem(PENDING_KEY);
      return p ? JSON.parse(p) : [];
    } catch(e) { return []; }
  }

  function addPending(r) {
    var q = getPending();
    if (!q.some(function(x) { return x.ts === r.ts; })) {
      q.push(r);
      try { localStorage.setItem(PENDING_KEY, JSON.stringify(q)); } catch(e) {}
    }
  }

  function removePending(ts) {
    var q = getPending().filter(function(x) { return x.ts !== ts; });
    try { localStorage.setItem(PENDING_KEY, JSON.stringify(q)); } catch(e) {}
  }

  function flushPending() {
    var q = getPending();
    if (!q.length) return;
    console.log('[FMX Reviews] Flushing ' + q.length + ' pending review(s) to Firebase...');
    q.forEach(function(r) {
      firebaseSave(r, function(ok) {
        if (ok) {
          removePending(r.ts);
          console.log('[FMX Reviews] Flushed pending review:', r.ts);
        }
      });
    });
  }

  /* ═══════════════════════════════════════════════════════════════
     STATIC REVIEWS MERGE
     Reads window.FMX_STATIC_REVIEWS (set in the liquid template),
     converts the short-key shape to the Firebase shape, de-duplicates
     against real Firebase/cached reviews (matched on name + title),
     and injects them with _static:true so they are:
       • Never written to Firebase
       • Never written to localStorage
       • Always present regardless of Firebase availability
  ════════════════════════════════════════════════════════════════ */
  var monthMap = {
    'january':1,'february':2,'march':3,'april':4,'may':5,'june':6,
    'july':7,'august':8,'september':9,'october':10,'november':11,'december':12
  };

  /* Parse "18 March 2025" → Unix ms timestamp for sorting */
  function parseDateToTs(dateStr) {
    try {
      if (!dateStr) return 0;
      var parts = dateStr.trim().split(/\s+/);
      if (parts.length === 3) {
        var day   = parseInt(parts[0], 10);
        var month = monthMap[parts[1].toLowerCase()] - 1;
        var year  = parseInt(parts[2], 10);
        var d = new Date(year, month, day);
        return isNaN(d.getTime()) ? 0 : d.getTime();
      }
      return new Date(dateStr).getTime() || 0;
    } catch(e) { return 0; }
  }

  function mergeStaticReviews() {
    var statics = window.FMX_STATIC_REVIEWS;
    if (!Array.isArray(statics) || !statics.length) return;

    /* Build lookup of reviews already in the list (by name + title) */
    var existing = {};
    reviews.forEach(function(r) {
      var key = (String(r.name || '') + '||' + String(r.title || '')).toLowerCase();
      existing[key] = true;
    });

    statics.forEach(function(s) {
      var key = (String(s.n || '') + '||' + String(s.t || '')).toLowerCase();
      if (existing[key]) return; /* already present as a real Firebase review — skip */

      reviews.push({
        rating:    s.r,
        name:      s.n  || '',
        title:     s.t  || '',
        body:      s.b  || '',
        fit:       s.ft || 'True to Size',
        comfort:   s.cm || 'Average',
        recommend: s.rc || 'Yes',
        date:      s.d  || '',
        ts:        parseDateToTs(s.d),
        images:    [],
        _static:   true   /* flag: skip cache + Firebase writes */
      });
    });
  }
  /* ═══════════════════════════════════════════════════════════════ */

  /* ── 4. Firebase: load all reviews for this product ── */
  function firebaseLoad(callback, attempt) {
    attempt = attempt || 1;

    if (FIREBASE_DB_URL.indexOf('YOUR-PROJECT-ID') !== -1) {
      console.warn('[FMX Reviews] Firebase URL not set.');
      callback(null);
      return;
    }

    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timeoutId  = controller ? setTimeout(function() { controller.abort(); }, 10000) : null;

    fetch(FIREBASE_BASE + '.json', controller ? { signal: controller.signal } : {})
      .then(function(res) {
        if (timeoutId) clearTimeout(timeoutId);
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function(data) {
        if (!data) { callback([]); return; }
        var arr = Object.keys(data).map(function(k) {
          var r = data[k];
          r._fbKey = k;
          return r;
        });
        arr.sort(function(a, b) { return (b.ts || 0) - (a.ts || 0); });
        callback(arr);
      })
      .catch(function(err) {
        if (timeoutId) clearTimeout(timeoutId);
        console.error('[FMX Reviews] Firebase load error (attempt ' + attempt + '):', err);
        if (attempt < 3) {
          setTimeout(function() { firebaseLoad(callback, attempt + 1); }, attempt * 1500);
        } else {
          console.warn('[FMX Reviews] All Firebase load attempts failed — using local cache.');
          callback(null);
        }
      });
  }

  /* ── 5. Firebase: save a single new review ── */
  function firebaseSave(review, callback) {
    /* Never push static reviews to Firebase */
    if (review._static) {
      if (callback) callback(false);
      return;
    }

    var fbReview = {};
    Object.keys(review).forEach(function(k) {
      if (k !== 'images' && k !== '_static') fbReview[k] = review[k];
    });

    if (FIREBASE_DB_URL.indexOf('YOUR-PROJECT-ID') !== -1) {
      console.warn('[FMX Reviews] Firebase URL not set — review saved locally only.');
      cacheReviews();
      addPending(review);
      if (callback) callback(false);
      return;
    }

    fetch(FIREBASE_BASE + '.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(fbReview)
    })
      .then(function(res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function(data) {
        review._fbKey = data.name;
        cacheReviews();
        removePending(review.ts);
        if (callback) callback(true);
      })
      .catch(function(err) {
        console.error('[FMX Reviews] Firebase save error — queuing for retry:', err);
        cacheReviews();
        addPending(review);
        if (callback) callback(false);
      });
  }

  /* ── Fit/comfort maps ── */
  var fitMap     = { 'Runs Small': 0, 'True to Size': 0.5, 'Runs Big': 1 };
  var comfortMap = { 'Uncomfortable': 0, 'Average': 0.5, 'Very Comfortable': 1 };
  function pos(m, v) { return m[v] !== undefined ? m[v] : 0.5; }

  /* ── Helpers ── */
  function esc(s) {
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  /* ── Inject product info into modal ── */
  if (modalProduct && (PRODUCT_TITLE || PRODUCT_IMAGE)) {
    var imgHtml = PRODUCT_IMAGE
      ? '<img src="' + PRODUCT_IMAGE + '" alt="' + esc(PRODUCT_TITLE) + '" class="fmx-rv-modal__product-img">'
      : '';
    modalProduct.innerHTML =
      imgHtml +
      '<div>' +
        (PRODUCT_TITLE ? '<p class="fmx-rv-modal__product-name">' + esc(PRODUCT_TITLE) + '</p>' : '') +
        (PRODUCT_PRICE ? '<p class="fmx-rv-modal__product-price">' + esc(PRODUCT_PRICE) + '</p>' : '') +
      '</div>';
  }

  function starsHtml(r, cls) {
    var h = '', c = cls || 'fmx-rv__dstar';
    for (var i = 1; i <= 5; i++) {
      h += '<span class="' + c + ' ' + (i <= r ? c + '--on' : c + '--off') + '">★</span>';
    }
    return h;
  }

  var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

  /* ── Elements ── */
  var toggleBtn   = document.getElementById('fmxToggle');
  var bodyEl      = document.getElementById('fmxBody');
  var empty       = document.getElementById('fmxEmpty');
  var compactList = document.getElementById('fmxCompactList');
  var moreWrap    = document.getElementById('fmxMoreWrap');
  var moreBtn     = document.getElementById('fmxMoreBtn');
  var moreLabel   = document.getElementById('fmxMoreLabel');

  var allPanel    = document.getElementById('fmxAll');
  var allClose    = document.getElementById('fmxAllClose');
  var allWriteBtn = document.getElementById('fmxAllWriteBtn');
  var fullList    = document.getElementById('fmxFullList');
  var noResults   = document.getElementById('fmxNoResults');

  var modal       = document.getElementById('fmxModal');
  var backdrop    = document.getElementById('fmxBackdrop');
  var closeBtn    = document.getElementById('fmxClose');
  var form        = document.getElementById('fmxForm');
  var success     = document.getElementById('fmxSuccess');
  var doneBtn     = document.getElementById('fmxDone');
  var searchInput = document.getElementById('fmxSearch');

  /* ── Collapse/expand ── */
  toggleBtn.addEventListener('click', function () {
    var open = toggleBtn.getAttribute('aria-expanded') === 'true';
    toggleBtn.setAttribute('aria-expanded', String(!open));
    bodyEl.style.display = open ? "none" : "";
  });

  /* ── Open / close all-reviews overlay ── */
  moreBtn.addEventListener('click', function () {
    allPanel.style.display = "";
    document.body.style.overflow = 'hidden';
    renderFullList();
  });

  function closeAll() {
    allPanel.style.display = "none";
    document.body.style.overflow = '';
  }

  allClose.addEventListener('click', closeAll);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (modal.style.display !== "none") closeModal();
      else if (allPanel.style.display !== "none") closeAll();
    }
  });

  /* ── Sort & filter dropdowns ── */
  var sortBtn  = document.getElementById('fmxSortBtn');
  var sortMenu = document.getElementById('fmxSortMenu');
  var starBtn  = document.getElementById('fmxStarBtn');
  var starMenu = document.getElementById('fmxStarMenu');

  sortBtn.addEventListener('click', function (e) {
    e.stopPropagation();
    sortMenu.style.display = sortMenu.style.display === "none" ? "" : "none";
    starMenu.style.display = "none";
  });

  starBtn.addEventListener('click', function (e) {
    e.stopPropagation();
    starMenu.style.display = starMenu.style.display === "none" ? "" : "none";
    sortMenu.style.display = "none";
  });

  document.addEventListener('click', function () {
    sortMenu.style.display = "none";
    starMenu.style.display = "none";
  });

  sortMenu.querySelectorAll('.fmx-all__dropdown-item').forEach(function (btn) {
    btn.addEventListener('click', function () {
      sortMode = btn.getAttribute('data-sort');
      sortMenu.querySelectorAll('.fmx-all__dropdown-item').forEach(function (b) { b.classList.remove('fmx-all__dropdown-item--active'); });
      btn.classList.add('fmx-all__dropdown-item--active');
      sortBtn.childNodes[0].textContent = 'Sort';
      sortMenu.style.display = "none";
      renderFullList();
    });
  });

  starMenu.querySelectorAll('.fmx-all__dropdown-item').forEach(function (btn) {
    btn.addEventListener('click', function () {
      starFilter = parseInt(btn.getAttribute('data-stars'), 10);
      starMenu.querySelectorAll('.fmx-all__dropdown-item').forEach(function (b) { b.classList.remove('fmx-all__dropdown-item--active'); });
      btn.classList.add('fmx-all__dropdown-item--active');
      starMenu.style.display = "none";
      renderFullList();
    });
  });

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      searchQ = searchInput.value.toLowerCase();
      renderFullList();
    });
  }

  /* ── Open write modal ── */
  function openModal() {
    modal.style.display = "";
    document.body.style.overflow = 'hidden';
    modal.querySelector('.fmx-rv-modal__panel').scrollTop = 0;
    success.style.display = 'none';
    form.style.display = '';
    resetForm();
  }

  function closeModal() {
    modal.style.display = "none";
    document.body.style.overflow = (allPanel.style.display !== "none") ? 'hidden' : '';
  }

  document.getElementById('fmxWriteBtn').addEventListener('click', openModal);
  allWriteBtn.addEventListener('click', openModal);
  closeBtn.addEventListener('click', closeModal);
  backdrop.addEventListener('click', closeModal);
  doneBtn.addEventListener('click', closeModal);

  /* ── Star selector in form ── */
  var starBtns = document.querySelectorAll('.fmx-rv-modal__sbtn');

  function paintStars(v) {
    starBtns.forEach(function (b) {
      b.classList.toggle('is-active', parseInt(b.getAttribute('data-val'), 10) <= v);
    });
  }

  starBtns.forEach(function (btn) {
    btn.addEventListener('mouseenter', function () { paintStars(parseInt(btn.getAttribute('data-val'), 10)); });
    btn.addEventListener('mouseleave', function () { paintStars(formRating); });
    btn.addEventListener('click',      function () { formRating = parseInt(btn.getAttribute('data-val'), 10); paintStars(formRating); });
  });

  /* ── Photo upload ── */
  var photoInput    = document.getElementById('fmxPhotos');
  var photoPreviews = document.getElementById('fmxPhotoPreviews');
  var selectedFiles = [];

  photoInput.addEventListener('change', function () {
    Array.from(photoInput.files).forEach(function (file) {
      if (selectedFiles.length >= 5) return;
      var reader = new FileReader();
      reader.onload = function (e) {
        var base64 = e.target.result;
        selectedFiles.push(base64);
        var img = document.createElement('img');
        img.src = base64;
        img.className = 'fmx-rv-modal__thumb';
        img.alt = 'Review photo ' + selectedFiles.length;
        photoPreviews.appendChild(img);
      };
      reader.readAsDataURL(file);
    });
    photoInput.value = '';
  });

  /* ── Validation ── */
  function clearErrors() {
    ['fmxErrRating','fmxErrBody','fmxErrFit','fmxErrComfort','fmxErrRecommend','fmxErrName','fmxErrTerms'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.textContent = '';
    });
    document.querySelectorAll('.fmx-rv-modal__input--err, .fmx-rv-modal__textarea--err').forEach(function (el) {
      el.classList.remove('fmx-rv-modal__input--err', 'fmx-rv-modal__textarea--err');
    });
  }

  function setErr(errId, msg, fieldEl) {
    var el = document.getElementById(errId);
    if (el) el.textContent = msg;
    if (fieldEl) {
      if (fieldEl.tagName === 'TEXTAREA') fieldEl.classList.add('fmx-rv-modal__textarea--err');
      else if (fieldEl.tagName === 'INPUT') fieldEl.classList.add('fmx-rv-modal__input--err');
    }
  }

  function validate() {
    var ok = true;
    var firstErrEl = null;

    if (!formRating) {
      setErr('fmxErrRating', 'Please select a star rating before submitting.');
      if (!firstErrEl) firstErrEl = document.getElementById('fmxErrRating');
      ok = false;
    }

    var bodyField = document.getElementById('fmxReviewText');
    if (!bodyField.value.trim()) {
      setErr('fmxErrBody', 'Please write your review before submitting.', bodyField);
      if (!firstErrEl) firstErrEl = bodyField;
      ok = false;
    } else if (bodyField.value.trim().length < 30) {
      setErr('fmxErrBody', 'Your review must be at least 30 characters.', bodyField);
      if (!firstErrEl) firstErrEl = bodyField;
      ok = false;
    }

    if (!document.querySelector('input[name="fit"]:checked')) {
      setErr('fmxErrFit', 'Please tell us how this product fit.');
      if (!firstErrEl) firstErrEl = document.getElementById('fmxErrFit');
      ok = false;
    }

    if (!document.querySelector('input[name="comfort"]:checked')) {
      setErr('fmxErrComfort', 'Please rate the comfort of this product.');
      if (!firstErrEl) firstErrEl = document.getElementById('fmxErrComfort');
      ok = false;
    }

    if (!document.querySelector('input[name="recommend"]:checked')) {
      setErr('fmxErrRecommend', 'Please let us know if you would recommend this product.');
      if (!firstErrEl) firstErrEl = document.getElementById('fmxErrRecommend');
      ok = false;
    }

    var nameEl = document.getElementById('fmxName');
    if (!nameEl.value.trim()) {
      setErr('fmxErrName', 'Please enter your name.', nameEl);
      if (!firstErrEl) firstErrEl = nameEl;
      ok = false;
    }

    if (!document.getElementById('fmxTerms').checked) {
      setErr('fmxErrTerms', 'You must agree to the terms before submitting.');
      if (!firstErrEl) firstErrEl = document.getElementById('fmxErrTerms');
      ok = false;
    }

    if (firstErrEl) firstErrEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return ok;
  }

  /* ── Reset form ── */
  function resetForm() {
    form.reset();
    formRating = 0;
    paintStars(0);
    selectedFiles = [];
    photoPreviews.innerHTML = '';
    clearErrors();
  }

  /* ── Form submit ── */
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    clearErrors();
    if (!validate()) return;

    var now = new Date();
    var r = {
      rating:    formRating,
      body:      document.getElementById('fmxReviewText').value.trim(),
      title:     document.getElementById('fmxHeadline').value.trim(),
      fit:       (document.querySelector('input[name="fit"]:checked') || {}).value || '',
      comfort:   (document.querySelector('input[name="comfort"]:checked') || {}).value || '',
      recommend: (document.querySelector('input[name="recommend"]:checked') || {}).value || '',
      name:      document.getElementById('fmxName').value.trim(),
      date:      now.getDate() + ' ' + months[now.getMonth()] + ' ' + now.getFullYear(),
      ts:        now.getTime(),
      images:    selectedFiles.slice()
    };

    /* Insert at the front of the reviews array (before static reviews) */
    reviews.unshift(r);

    firebaseSave(r, function(ok) {
      if (!ok) console.warn('[FMX Reviews] Saved locally only — check Firebase config.');
    });

    if (!bodyEl.style.display || bodyEl.style.display === "none") {
      bodyEl.style.display = "";
      toggleBtn.setAttribute('aria-expanded', 'true');
    }

    empty.style.display = 'none';
    moreWrap.style.display = '';
    compactList.style.display = '';

    updateCompact();
    updateStats();
    if (allPanel.style.display !== "none") { renderFullList(); updateAllSummary(); }

    form.style.display = 'none';
    success.style.display = 'flex';
  });

  /* ── Compact card renderer ── */
  function renderCompactCard(r) {
    var el = document.createElement('div');
    el.className = 'fmx-rv__compact-item';
    el.innerHTML =
      (r.title ? '<h4 class="fmx-rv__compact-title">' + esc(r.title) + '</h4>' : '') +
      '<div class="fmx-rv__compact-row">' +
        '<span class="fmx-rv__compact-stars">' + starsHtml(r.rating) + '</span>' +
        '<span class="fmx-rv__compact-meta">' + esc(r.name) + ' — ' + r.date + '</span>' +
      '</div>';
    return el;
  }

  function updateCompact() {
    compactList.innerHTML = '';
    reviews.slice(0, 5).forEach(function (r) {
      compactList.appendChild(renderCompactCard(r));
    });
    moreLabel.textContent = 'See all ' + reviews.length + ' review' + (reviews.length !== 1 ? 's' : '');
  }

  /* ── Stats update ── */
  function avgRating() {
    if (!reviews.length) return 0;
    return reviews.reduce(function (a, r) { return a + r.rating; }, 0) / reviews.length;
  }

  function updateStats() {
    var n = reviews.length;
    if (!n) return;
    var avg = avgRating();

    document.getElementById('fmxHeaderStars').querySelectorAll('.fmx-rv__hstar').forEach(function (s, i) {
      if (i < Math.round(avg)) {
        s.textContent = '★'; s.style.color = '#12120e'; s.style.opacity = '1';
      } else {
        s.textContent = '☆'; s.style.color = '#12120e'; s.style.opacity = '0.4';
      }
    });

    document.getElementById('fmxRvCount').textContent = '(' + n + ')';

    document.getElementById('fmxAvgStars').querySelectorAll('.fmx-rv__dstar').forEach(function (s, i) {
      s.className = 'fmx-rv__dstar ' + (i < Math.round(avg) ? 'fmx-rv__dstar--on' : 'fmx-rv__dstar--off');
    });
    document.getElementById('fmxAvgLabel').textContent = (Math.round(avg * 10) / 10).toFixed(1) + ' stars';
  }

  /* ── All reviews summary ── */
  function updateAllSummary() {
    var n = reviews.length;
    if (!n) return;
    var avg     = avgRating();
    var fitAvg  = reviews.reduce(function (a, r) { return a + pos(fitMap, r.fit); }, 0) / n;
    var comfAvg = reviews.reduce(function (a, r) { return a + pos(comfortMap, r.comfort); }, 0) / n;
    var yesN    = reviews.filter(function (r) { return r.recommend === 'Yes'; }).length;

    document.getElementById('fmxAllScore').textContent = (Math.round(avg * 10) / 10).toFixed(1);
    document.getElementById('fmxAllScoreStars').innerHTML = starsHtml(Math.round(avg));

    document.getElementById('fmxAllAttrs').innerHTML =
      attrBar('How did this product fit?', fitAvg, 'Runs Small', 'Runs Big') +
      attrBar('How comfortable was this product?', comfAvg, 'Uncomfortable', 'Very Comfortable') +
      '<div class="fmx-all__attr-block fmx-all__attr-block--full">' +
        '<span class="fmx-all__attr-label">Would you recommend this product?</span>' +
        '<span style="font-size:14px;color:#555;">Yes (' + yesN + ')</span>' +
      '</div>';

    document.getElementById('fmxAllCount').textContent = n + ' Review' + (n !== 1 ? 's' : '');
  }

  function attrBar(label, frac, left, right) {
    return '<div class="fmx-all__attr-block">' +
      '<span class="fmx-all__attr-label">' + label + '</span>' +
      '<div class="fmx-all__attr-track"><div class="fmx-all__attr-dot" style="left:calc(' + (frac * 100) + '% - 6px);"></div></div>' +
      '<div class="fmx-all__attr-ends"><span>' + left + '</span><span>' + right + '</span></div>' +
      '</div>';
  }

  /* ── Full review card ── */
  function renderFullCard(r) {
    var fp = pos(fitMap, r.fit) * 100;
    var cp = pos(comfortMap, r.comfort) * 100;

    var imagesHtml = '';
    if (r.images && r.images.length) {
      imagesHtml = '<div class="fmx-all__images">' +
        r.images.map(function (src) {
          return '<img src="' + src + '" class="fmx-all__img" alt="Review photo" loading="lazy">';
        }).join('') +
      '</div>';
    }

    var el = document.createElement('div');
    el.className = 'fmx-all__item';
    el.innerHTML =
      '<div class="fmx-all__item-left">' +
        '<div class="fmx-all__item-stars">' + starsHtml(r.rating) + '</div>' +
        '<div class="fmx-all__item-attrs">' +
          iAttr('How did this product fit?', r.fit, fp, 'Runs Small', 'Runs Big') +
          iAttr('How comfortable was this product?', r.comfort, cp, 'Uncomfortable', 'Very Comfortable') +
          '<div class="fmx-all__iattr"><div class="fmx-all__iattr-question">Would you recommend this product?</div><div class="fmx-all__iattr-answer">' + esc(r.recommend) + '</div></div>' +
        '</div>' +
      '</div>' +
      '<div class="fmx-all__item-right">' +
        (r.title ? '<h4 class="fmx-all__item-title">' + esc(r.title) + '</h4>' : '') +
        '<p class="fmx-all__item-body">' + esc(r.body) + '</p>' +
        imagesHtml +
        '<div class="fmx-all__item-meta">' +
          '<span class="fmx-all__item-author">' + esc(r.name) + '</span>' +
          '<span class="fmx-all__item-date">' + esc(r.date) + '</span>' +
        '</div>' +
        '<div class="fmx-all__item-actions">' +
          '<button class="fmx-all__item-act" type="button">↑ 0</button>' +
          '<button class="fmx-all__item-act" type="button">↓ 0</button>' +
          '<button class="fmx-all__item-act" type="button">⚑ Flagged</button>' +
        '</div>' +
      '</div>';
    return el;
  }

  function iAttr(label, val, pct, left, right) {
    return '<div class="fmx-all__iattr">' +
      '<div class="fmx-all__iattr-question">' + label + '</div>' +
      '<div class="fmx-all__iattr-answer">' + esc(val) + '</div>' +
      '<div class="fmx-all__iattr-track"><div class="fmx-all__iattr-dot" style="left:calc(' + pct + '% - 6px);"></div></div>' +
      '<div class="fmx-all__iattr-ends"><span>' + left + '</span><span>' + right + '</span></div>' +
      '</div>';
  }

  /* ── Render full filtered/sorted list ── */
  function renderFullList() {
    updateAllSummary();

    var filtered = reviews.filter(function (r) {
      if (starFilter && r.rating !== starFilter) return false;
      if (searchQ && !((r.title + ' ' + r.body + ' ' + r.name).toLowerCase().includes(searchQ))) return false;
      return true;
    });

    var sorted = filtered.slice().sort(function (a, b) {
      if (sortMode === 'highest') return b.rating - a.rating;
      if (sortMode === 'lowest')  return a.rating - b.rating;
      return (b.ts || 0) - (a.ts || 0);
    });

    Array.from(fullList.querySelectorAll('.fmx-all__item')).forEach(function (el) { el.remove(); });

    if (!sorted.length) {
      noResults.style.display = '';
    } else {
      noResults.style.display = 'none';
      sorted.forEach(function (r) { fullList.appendChild(renderFullCard(r)); });
    }
  }

  /* ── Render from current reviews array ── */
  function renderFromReviews() {
    if (!reviews.length) {
      empty.style.display = '';
      moreWrap.style.display = 'none';
      compactList.style.display = 'none';
      return;
    }
    empty.style.display = 'none';
    moreWrap.style.display = '';
    compactList.style.display = '';
    updateCompact();
    updateStats();
  }

  /* ── Init: two-phase load ──
     Phase 1: render from local cache + static reviews immediately
     Phase 2: fetch from Firebase, merge with static, re-render
  ── */
  function init() {
    /* Phase 1 — show cached Firebase reviews + static reviews instantly */
    var hasCached = loadCache();
    mergeStaticReviews(); /* always inject static reviews regardless of cache */
    reviews.sort(function(a, b) { return (b.ts || 0) - (a.ts || 0); });
    renderFromReviews();

    /* Phase 2 — fetch from Firebase, then merge static on top */
    firebaseLoad(function(fbReviews) {
      if (fbReviews === null) {
        /* Firebase unreachable — we already showed cache + static in Phase 1 */
        console.warn('[FMX Reviews] Firebase unreachable — showing cache + static reviews.');
        flushPending();
        return;
      }

      /* Re-attach locally-uploaded images by matching timestamp */
      var localCache = [];
      try {
        var c = localStorage.getItem(CACHE_KEY);
        if (c) localCache = JSON.parse(c) || [];
      } catch(e) {}

      var fbTsSet = {};
      reviews = fbReviews.map(function(r) {
        fbTsSet[r.ts] = true;
        var local = localCache.filter(function(l) { return l.ts === r.ts; })[0];
        if (local && local.images && local.images.length) {
          r.images = local.images;
        }
        return r;
      });

      /* Orphan recovery: locally-cached reviews not yet in Firebase */
      localCache.forEach(function(local) {
        if (!fbTsSet[local.ts]) {
          console.log('[FMX Reviews] Orphan review found — uploading to Firebase:', local.ts);
          if (!reviews.some(function(r) { return r.ts === local.ts; })) {
            reviews.push(local);
          }
          firebaseSave(local, function(ok) {
            if (ok) console.log('[FMX Reviews] Orphan review synced:', local.ts);
          });
        }
      });

      flushPending();

      /* Merge static reviews on top of the fresh Firebase data */
      mergeStaticReviews();

      /* Sort newest first across all sources */
      reviews.sort(function(a, b) { return (b.ts || 0) - (a.ts || 0); });

      /* Cache only the real Firebase reviews (not static) */
      cacheReviews();

      renderFromReviews();
      console.log('[FMX Reviews] Loaded ' + reviews.filter(function(r){return !r._static;}).length + ' Firebase review(s) + ' + reviews.filter(function(r){return r._static;}).length + ' static review(s).');
    });
  }

  init();

}());